import React, { useEffect, useState, useMemo } from "react";
import CONFIG from "Config";
import { EAIClient } from "../../../services/EAIClient";

const VersionInfo = () => {
    const [envData, setEnvData] = useState<any>(null);
    const [gitBranch, setGitBranch] = useState<string | null>(null);
    const [apiStage, setApiStage] = useState<string>("N/A");
    const [migrationVersion, setMigrationVersion] = useState<string>("Unknown");

    const stage = process.env.STAGE;
    const isStageAllowed = stage === "local" || stage === "test";

    const uiStage = stage || "N/A";
    const uiBranch = CONFIG.branch || "N/A";
    const apiBranch = gitBranch || "N/A";

    useEffect(() => {
        if (!isStageAllowed) return;

        const client = new EAIClient();

        const fetchAll = async () => {
            try {
                const [env, branch, stage, migration] = await Promise.all([
                    client.getEnvConfig(),
                    client.getGitBranch(),
                    client.getApiStage(),
                    client.getMigrationVersion(),
                ]);

                setEnvData(env);
                setGitBranch(branch);
                setApiStage(stage);
                setMigrationVersion(migration);
            } catch (err) {
                console.error("Error fetching env info:", err);
            }
        };

        fetchAll();
    }, [isStageAllowed]);

    const { dbHost, dbName } = useMemo(() => {
        const uri: string = envData?.SQLALCHEMY_DATABASE_URI_DISPLAY || "";
        const host = uri ? uri.substring(0, uri.lastIndexOf("/")) : "N/A";
        const name = uri ? uri.split("/").pop()?.split("?")[0] || "N/A" : "N/A";
        return { dbHost: host, dbName: name };
    }, [envData]);

    const getBackgroundColor = (): string => {
        if (uiBranch === "master" || apiBranch === "master") return "#DF2935";
        if (uiBranch === "develop" || apiBranch === "develop") return "#FDCA40";
        return "#0471A6";
    };

    const getWarningMessage = (): string => {
        if (uiBranch === "master" || apiBranch === "master") return "Warning: You are on the MASTER branch!";
        if (uiBranch === "develop" || apiBranch === "develop") return "Caution: You are on the DEVELOP branch.";
        return "You are on a safe branch.";
    };

    if (!isStageAllowed) return null;
    if (!envData || gitBranch === null) return <div>Loading...</div>;

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                gap: "3px",
                fontFamily: "monospace",
                fontSize: "8px",
                textAlign: "left",
                lineHeight: "1.5",
                position: "fixed",
                bottom: 10,
                left: 305,
                background: getBackgroundColor(),
                color: "white",
                padding: "5px",
                zIndex: 9999,
                borderRadius: "8px",
                boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            }}
        >
            <div>
                <div>UI STAGE: {uiStage}</div>
                <div>API STAGE: {apiStage}</div>
            </div>
            <br />
            <div>
                <div>UI Git Branch: {uiBranch}</div>
                <div>API Git Branch: {apiBranch}</div>
                <div>{getWarningMessage()}</div>
            </div>
            <br />
            <div>
                <div>DB HOST: {dbHost}</div>
                <div>DB Name: {dbName}</div>
                <div>Migration Revision: {migrationVersion}</div>
            </div>
        </div>
    );
};

export default VersionInfo;
